
/* eslint-disable */
// Import Greensock
import {TweenMax, TimelineMax} from 'gsap';
/* eslint-enable */

export default {
  init() {
    // JavaScript to be fired on the home page

    // Home intro animation full - Desktop
    function homeIntroAnimationFullDesktop() {
      // Declare variables
      let bodyOverLay = $('.body-overlay');
      let introLogo = $('.intro-logo');
      let navigation = $('#navigation');

      // Timeline animation
      let introAnimFullTL = new TimelineMax({paused: true});
      introAnimFullTL
          .to(introLogo, 1.5, {autoAlpha: 1, delay: 1, ease: Power4.easeInOut})
          .to(introLogo, 1, {autoAlpha: 0, delay: 1, ease: Power4.easeInOut})
          .to(bodyOverLay, 1, {autoAlpha: 0, delay: 1, ease: Power4.easeInOut}, '-=1')
          .to(navigation, 1, {autoAlpha: 1, delay: 1, ease: Power4.easeInOut}, '-=1');
      return introAnimFullTL;
    }
    // Store a reference to the timeline that was created to control it later
    let homeIntroAnimationFullDesktopController = homeIntroAnimationFullDesktop();


    function homeIntro() {
      homeIntroAnimationFullDesktopController.timeScale(1).play();
    }

    $(document).ready(homeIntro);

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js